//LOCAL CONFIG
// export const VUE_APP_API_URL = "http://185.170.214.22:9000/api/";
//export const VUE_APP_API_URL = "http://185.170.214.22:9000/api/";
//export const VUE_APP_API_URL = "http://localhost:9000/api/";
const getApiUrl = () => {
  if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_ENV === 'test') {
    return "http://localhost:9000/api/";
  } else if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_ENV === 'prod') {
    return "https://oeccabenin.bj/api/";
  } else {
    // Par défaut en production
    return "https://oeccabenin.bj/api/";
  }
};

export const VUE_APP_API_URL = getApiUrl();
export const VUE_APP_BASE_URL = "/";
export const COOKIES_EXPIRE = "60MIN";
export const FEDAPAY_TOKEN = 'pk_live__YQLjnl6UbblixpwMlRRU0U_'; // Production
//export const FEDAPAY_TOKEN = 'pk_sandbox_kYNq3V6SLf4IT3A4B-GWEals'; // Test
export const KKIAPAY_API_KEY = 'a221823a7704c69db43dff4e1dbb346e4d08b02f'; // Production
//export const KKIAPAY_API_KEY = '4e312a30eb3e11f0b1ee25391768bb9b'; // Test
export const ENCRYPTION_KEY = 'OECCA2025!SecureAuth#UserCredentials$BJ';